import { createSlice } from "@reduxjs/toolkit";

const SchemaIDSession = createSlice({
  name: "SchemaIDSession",
  initialState: "",
  reducers: {
    saveSchemaIDSession: (state, action) => action.payload,
  },
});

export default SchemaIDSession;
